import React from 'react';
export function Gallery() {
  const images = [{
    url: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=800&q=80',
    alt: 'Fresh sashimi platter with artistic presentation'
  }, {
    url: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=800&q=80',
    alt: 'Elegant restaurant interior with warm lighting'
  }, {
    url: 'https://images.unsplash.com/photo-1583623025817-d180a2221d0a?w=800&q=80',
    alt: 'Premium sushi selection on traditional plate'
  }, {
    url: 'https://images.unsplash.com/photo-1580959375944-57c8e2a97128?w=800&q=80',
    alt: 'Grilled fish with seasonal garnish'
  }, {
    url: 'https://images.unsplash.com/photo-1564489563601-c53cfc451e93?w=800&q=80',
    alt: 'Intimate dining area with Japanese decor'
  }, {
    url: 'https://images.unsplash.com/photo-1544025162-d76694265947?w=800&q=80',
    alt: 'Wagyu beef dish with artistic plating'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-black" data-id="element-43">
      <div className="max-w-7xl mx-auto" data-id="element-44">
        <div className="text-center mb-16" data-id="element-45">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4" data-id="element-46">
            Gallery
          </h2>
          <p className="text-xl text-gray-300" data-id="element-47">
            A glimpse into the Kumo experience
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-48">
          {images.map((image, index) => <div key={index} className="group relative aspect-square overflow-hidden rounded-xl bg-slate-950 border border-slate-800" data-id="element-49">
              <img src={image.url} alt={image.alt} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-50" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300" data-id="element-51" />
            </div>)}
        </div>
      </div>
    </section>;
}